// extracted by mini-css-extract-plugin
export default {"headerSection":"SettingsTabSection_headerSection__k3BTE"};